/**
 * Created by Allan on 2022/08/03.
 * Contact 84880528@qq.com.
 * 文字格式化
 * value为空或null转化为 -
 */
export default function(value){
    /*if(!value) return;*/
    return value==='' || value===null?'--':value
}



// WEBPACK FOOTER //
// ./src/smspromo/filter/module/txtDefault.js